import type {
  AiChatRecommendClassBody,
  AiChatRecommendClassListResponse,
  SuggestionLearningMapProgressResultResponse
} from '@/models/interface/aiChat';
import { ApiFactory, type ApiDataResponse, type ApiResponse } from '@/utils/api';

const baseUrl: string = import.meta.env.VITE_FUNDAY_API_URL;

export class AiChatSuggestionService extends ApiFactory {
  constructor() {
    super(`${baseUrl}`);
  }

  /**
   * 取得 指標名稱與累積百分比
   */
  getLearningIndicatorsPercentList(): Promise<ApiDataResponse<{ [key: string]: number }>> {
    return super.get(`v1/UserReports/LearningIndicatorsPercentList`);
  }
  /**
   * 取得 每周學習進度
   */
  getLearningMapProgressResult(): Promise<
    ApiDataResponse<SuggestionLearningMapProgressResultResponse>
  > {
    return super.get(`v1/LearningMap/ProgressResult`);
  }
  /**
   * 建立 尚未開課的推薦課程 (兩周大課表)
   * @param body - 推薦課程偏好資料
   */
  createRecommendClass(
    body: AiChatRecommendClassBody
  ): Promise<ApiDataResponse<AiChatRecommendClassListResponse>> {
    return super.post(`v1/Schedule/RecommendClass`, body, {
      headers: {
        'Content-Type': 'application/json'
      },
      timeout: 30000
    });
  }
  /**
   * 建立 課程提醒 (加入行事曆)
   * @param body - 課程提醒資料
   */
  createClassReminder(classId: string): Promise<ApiDataResponse<string | null>> {
    return super.post(`v1/TutorClass/SetClassReminder`, null, {
      headers: {
        'Content-Type': 'application/json'
      },
      params: {
        classId
      }
    });
  }
  /**
   * 取消 課程提醒 (取消行事曆紀錄)
   * @param body - 課程提醒資料
   */
  deleteClassReminder(classId: string): Promise<ApiResponse> {
    return super.delete(`v1/TutorClass/CancelClassReminder?classId=${classId}`);
  }
}
